import { observer } from 'mobx-react-lite';
import React, { Fragment, useEffect, useState } from 'react'
import { getTaxesForOntarioHardCoded, Taxes } from '../../../app/models/Taxes';
import { useStore } from '../../../app/stores/Store';



const DocumentTaxes = () => {
    const { poStore/*, modalStore*/ } = useStore();
    const { loadingPO, currentPurchaseOrder, runningTotal, getNetAmount, computeTotals, updatePurchaseOrder } = poStore;

    const [taxdata/*, setTaxData*/] = useState<Taxes>(getTaxesForOntarioHardCoded());

    useEffect(() => {
        if (currentPurchaseOrder !== undefined && currentPurchaseOrder !== null)
            computeTotals(currentPurchaseOrder.purchaseOrderDetails);
    }, [computeTotals, currentPurchaseOrder])

    if (currentPurchaseOrder === null || loadingPO) {
        return <Fragment />
    }


    return (
        <Fragment>

            <div className="dtTaxesFlexBox">


                {currentPurchaseOrder.po_invoice_no ? (
                    <div className="dtCommentsGrid">
                        <div className="dtGridHeading">Remarks:</div>
                        <div className="dtGridTextArea">
                            <textarea
                                readOnly={true}
                                name='po_remarks'
                                rows={6}
                                cols={50}
                                value={currentPurchaseOrder.po_remarks}
                                onChange={(e) => updatePurchaseOrder(e.target.name, e.target.value)}
                            />
                        </div>
                        <div className="dtGridHeading">Client Notes:</div>
                        <div className="dtGridTextArea">
                            <textarea
                                readOnly={true}
                                rows={6}
                                cols={50}
                                className='tdRemarksTextArea'
                                name='po_client_notes'
                                value={currentPurchaseOrder.po_client_notes}
                                onChange={(e) => updatePurchaseOrder(e.target.name, e.target.value)}
                            />
                        </div>
                    </div>

                ) : (
                    <div className="dtCommentsGrid">
                        <div className="dtGridHeading">Remarks:</div>
                        <div className="dtGridTextArea">
                            <textarea
                                name='po_remarks'
                                rows={6}
                                cols={50}
                                value={currentPurchaseOrder.po_remarks}
                                onChange={(e) => updatePurchaseOrder(e.target.name, e.target.value)}
                            />
                        </div>
                        <div className="dtGridHeading">Client Notes:</div>
                        <div className="dtGridTextArea">
                            <textarea
                                rows={6}
                                cols={50}
                                className='tdRemarksTextArea'
                                name='po_client_notes'
                                value={currentPurchaseOrder.po_client_notes}
                                onChange={(e) => updatePurchaseOrder(e.target.name, e.target.value)}
                            />
                        </div>
                    </div>

                )}

                <div className="dtTaxTable">
                    <div className="dtCell dtHeading">Subtotal</div>
                    <div className="dtCell dtValue"> <p><b>{runningTotal}</b></p></div>
                    <div className="dtCell dtHeading">HST [13%]</div>
                    <div className="dtCell dtValue"><p>{currentPurchaseOrder.po_hst_amount}</p></div>
                    <div className="dtCell dtHeading">GST [0%]</div>
                    <div className="dtCell dtValue"> <p>{currentPurchaseOrder.po_gst_amount}</p></div>
                    <div className="dtCell dtHeading">PST [0%]</div>
                    <div className="dtCell dtValue"> <p>{currentPurchaseOrder.po_pst_amount}</p></div>
                    <div className="dtCell dtHeading">Total Amount</div>
                    <div className="dtCell dtValue"> <p>$ {getNetAmount(taxdata)}</p></div>
                </div>
            </div>

        </Fragment>
    )
}

export default observer(DocumentTaxes)
